export default "__VITE_ASSET__DA2kj2l0__"